module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "group group--narrow support"
  }, [_c('module-questionnaire', {
    attrs: {
      "intake-id": "intakeDetail",
      "next-route-prefix": "support",
      "on-complete-route": "appointment-type",
      "loading": _vm.loadingSingleQuestion
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "support__image",
    attrs: {
      "src": _vm.image,
      "alt": ""
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a60fb39e"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/questionnaire/SupportDetail.vue
// module id = 460
// module chunks = 0